const normalizeQuantity = (quantity) => {
  const isFloat = !Number.isInteger(quantity);

  if (quantity > 10) return `>10`;
  if (isFloat) return quantity.toFixed(1);
  return quantity;
};

export { normalizeQuantity };
